import { UPDATE_DP_FINALIZE_STATUS } from "src/DigitalProtocolModule/constants";

const initialStatus = {
  study_population_finalize_flag: false,
  arm_cohort_finalize_flag: false,
  soa_finalize_flag: false,
  endpoint_finalize_flag: false,
};

const dpFinalizeStatusReducer = (state = initialStatus, action) => {
  switch (action.type) {
    case UPDATE_DP_FINALIZE_STATUS:
      state = {
        ...state,
        ...action.payload,
      };
      break;
    default:
  }
  return state;
};
export default dpFinalizeStatusReducer;
